import { render, staticRenderFns } from "./requestHistory.modal.vue?vue&type=template&id=2c43cc09"
import script from "./requestHistory.modal.vue?vue&type=script&lang=js"
export * from "./requestHistory.modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports